import script from "./UploadPPOB.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadPPOB.vue?vue&type=script&setup=true&lang=js"

import "./UploadPPOB.vue?vue&type=style&index=0&id=77bc15d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77bc15d3"]])

export default __exports__